import { render, staticRenderFns } from "./FactionTreeCard.vue?vue&type=template&id=363abff1&"
import script from "./FactionTreeCard.vue?vue&type=script&lang=js&"
export * from "./FactionTreeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports